import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

/* Redux imports */
import thunk from "redux-thunk";
import reducer from "./redux/reducers";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";

let store;
//creates the redux store using the combined reducers and applies the thunk middleware for async
if (
    window.location.host === "archetto-app.52beta.ca" ||
    window.location.host === "localhost:8888"
) {
    store = createStore(
        reducer,
        compose(
            applyMiddleware(thunk),
            window.__REDUX_DEVTOOLS_EXTENSION__
                ? window.__REDUX_DEVTOOLS_EXTENSION__()
                : (f) => f
        )
    );
} else {
    store = createStore(reducer, compose(applyMiddleware(thunk)));
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
